import { Component } from 'react'
import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
  panelId?: string
}

interface State {
  error: Error | null
}

export class ChartErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  override componentDidCatch(error: Error) {
    console.error('[ChartErrorBoundary] panel=%s error=%s', this.props.panelId, error.message)
  }

  override render() {
    if (this.state.error) {
      return (
        <div className="flex h-full w-full flex-col items-center justify-center gap-3 bg-tv-bg-primary">
          <span className="text-sm font-semibold text-tv-text-secondary">Chart error</span>
          <span className="max-w-xs truncate text-center text-2xs text-tv-text-muted">
            {this.state.error.message}
          </span>
          <button
            type="button"
            onClick={() => this.setState({ error: null })}
            className="rounded border border-tv-border px-3 py-1 text-2xs text-tv-text-secondary hover:bg-tv-bg-tertiary hover:text-tv-text-primary"
          >
            Retry
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
